import styled, { css } from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';

export const Nav = styled.nav`
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 100;
  transition: background 0.3s ease, backdrop-filter 0.3s ease, border-color 0.3s ease;
  border-bottom: 1px solid transparent;

  &.active {
    background: rgba(5, 5, 5, 0.72);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  padding: 0 50px;
  z-index: 1;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

const logoStyles = css`
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Ubuntu', sans-serif;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: none;
    color: #fff;
  }
`;

export const NavLogo = styled(LinkS)`
  ${logoStyles}
`;
export const NavLogoRouter = styled(RouterLink)`
  ${logoStyles}
`;

export const Circle = styled.span`
  background: ${(props) => props.theme.text};
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 4px;
  align-self: flex-end;
  margin-bottom: 8px;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 1070px) {
    display: block;
    font-size: 1.7rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;

  @media screen and (max-width: 1070px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 72px;
  display: flex;
  align-items: center;
`;

const linkStyles = css`
  color: #c4ccd8;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 0.95rem;
  cursor: pointer;
  height: 100%;
  font-size: 0.98rem;
  font-weight: 500;
  font-family: 'Ubuntu', sans-serif;
  border-bottom: 3px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;

  &.active {
    border-bottom: 3px solid ${(props) => props.theme.text};
    color: ${(props) => props.theme.text};
  }
  &:hover {
    text-decoration: none;
    color: #fff;
  }
`;

export const NavLinks = styled(LinkS)`
  ${linkStyles}
`;
export const NavLinksRouter = styled(RouterLink)`
  ${linkStyles}
`;
